import {percent as calcPercent} from 'shared/utils/number/percent';
import {perDay} from 'core/LifeCycle';
import {valueOf} from 'ui/keyboard';

export function createPayload({budget, userInput}: AppState): AddSpendEventPayload {
  const absolute = valueOf(userInput.keyboard);
  const percent = calcPercent(absolute, perDay(budget));
  return {absolute, percent};
}
